import z from "zod";
const InvoiceSettings = z.object({
  taxId: z.object({
    country: z.string().optional(),
    type: z.string().optional(),
    value: z.string()
  }).optional(),
  additionalEmails: z.string().array()
});
export {
  InvoiceSettings
};
//# sourceMappingURL=billing.js.map